import {Layout, Tabs,} from "antd";
import React, {useEffect, useState} from "react";
import {Helmet as Head} from "react-helmet-async";
import TabPane from "antd/es/tabs/TabPane";
import MyCollectionOverview from "@mwPages/my-collection/MyCollectionOverview";
import MyCollectionTabs from "@mwPages/my-collection/MyCollectionTabs";
import useEnforceLoggedIn from "@hooks/useEnforceLoggedIn";
import {IssueFilters} from "@mwServices/Issue";
import useSearchView from "@hooks/useSearchView";
import {isEqual} from "underscore";

const MyCollectionPage = () => {
    useEnforceLoggedIn();

    const [activeTab, setActiveTab] = useState('my-collection');
    const { filters } = useSearchView();
    const [issueFilters, setIssueFilters] = useState<IssueFilters | null>(null);

    const goToCollectionWithFilters = (newFilters) => {
        setIssueFilters(newFilters);
        setActiveTab('my-collection');
    };

    useEffect(() => {
        if(filters && filters !== ''){
            const decodedFilters = JSON.parse(atob(decodeURIComponent(filters)));
            if(!isEqual(decodedFilters, issueFilters)){
                goToCollectionWithFilters(decodedFilters);
            }
        }
    }, [filters]);

    return (
        <Layout className="page">
            <Head>
                <title>My Collection</title>
            </Head>
            <Tabs activeKey={activeTab} onTabClick={(tabKey) => {setActiveTab(tabKey)}} size="large" className="myCollection"
                //   tabBarExtraContent={{
                //       left: <div className="myCollectionTabsLeftPadding" />,
                //       right: <div className="myCollectionTabsRightPadding" >
                //         <Button disabled shape="circle" size={"large"} className="whiteButton" icon={<SettingOutlined className='mar-top-neg2' />} />
                //       </div>,
                //   }}
            >
                <TabPane 
                    // tab="My Collection" 
                    key='my-collection'>
                    <MyCollectionOverview goToCollectionWithFilters={goToCollectionWithFilters} />
                    <MyCollectionTabs issueFilters={issueFilters} setIssueFilters={setIssueFilters} />
                </TabPane>

                {/*<TabPane tab="Insights & Profit" key='insights' disabled>*/}
                {/*    insights*/}
                {/*</TabPane>*/}
                {/*<TabPane tab="Pull List" key='pull-list' disabled>*/}
                {/*    pull list*/}
                {/*</TabPane>*/}
            </Tabs>
        </Layout>
    );
};

export default MyCollectionPage;
